export enum InteractionsObjectType {
  TRUE_FALSE = 'true-false',
  CHOICE = 'choice',
  FILL_IN = 'fill-in',
  LONG_FILL_IN = 'long-fill-in',
  LIKERT = 'likert',
  MATCHING = 'matching',
  PERFORMANCE = 'performance',
  SEQUENCING = 'sequencing',
  NUMERIC = 'numeric',
  OTHER = 'other',
  NONE = '',
}

export default interface InteractionsObjectInterface {
  id: string
  type: InteractionsObjectType
  timestamp: string
  weighting: string
  learner_response: string
  result: string
  latency: string
  description: string
  objectives: {
    childArray: Array<any>
    _count: string
    toJSON: Function
  }
  correct_responses: {
    childArray: Array<any>
    _count: string
    toJSON: Function
  }
  toJSON: Function
}
